export enum NavLogoKind {
	Epic = 1,
	EpicShare = 2,
	EpicResearch = 3,
	MyChart = 4,
	UserWeb = 5,
	OpenDotEpic = 6,
	Showroom = 7,
	ConnectionHub = 8,
	Cosmos = 9,
	Careers = 10,
	GetConnected = 1000,
}

export enum TextSize {
	Large = 1,
	Medium = 2,
	Small = 3,
}

export enum Breakpoint {
	xl = 1,
	lg = 2,
	md = 3,
}

export enum ItemsGap {
	Large = 1,
	Medium = 2,
	Small = 3,
}

export enum FontWeight {
	Light = 300,
	SemiBold = 600,
	ExtraBold = 800,
}

export enum SubmenuWidth {
	Large = 1,
	Medium = 2,
	Small = 3,
}

export enum DropShadowWeight {
	Light = 1,
	Heavy = 2,
}

export interface INavBarColors {
	readonly topBarBackground?: string;
	readonly hoverLogoBackground?: string;
	readonly logoFill?: string;
	readonly text?: string;
	readonly bottomBarSubmenuBackground?: string;
	readonly bottomBarSubmenuItemText?: string;
	readonly bottomBarBackground?: string;
	readonly submenuBorder?: string;
	readonly submenuBackground?: string;
	readonly hoverLogoFill?: string;
	readonly hoverText?: string;
	readonly selectedLogoBackground?: string;
	readonly selectedHoverLogoBackground?: string;
	readonly selectedLogoFill?: string;
	readonly selectedHoverLogoFill?: string;
	readonly mobileNavigationButton?: string;
	readonly mobileNavigationPaneBorder?: string;
	readonly standaloneEpicLogoBackground?: string;
	readonly bottomBarButtonBackground?: string;
	readonly bottomBarButtonHoverBackground?: string;
	readonly bottomBarButtonFocusBackground?: string;
	readonly bottomBarButtonText?: string;
	readonly chevronFill?: string;
	readonly chevronHoverFill?: string;
	readonly selectedBottomBarUnderlineBackground?: string;
	readonly selectedBottomBarItemBackground?: string;
	readonly selectedBottomBarItemHoverBackground?: string;
	readonly selectedHoverText?: string;
}

export interface ITopItem extends ITopItemCore {
	readonly subItems?: ITopSubItem[];
	readonly submenuWidth?: SubmenuWidth;
}
export interface ITopSubItem extends ITopItemCore {}
export interface ITopItemCore {
	readonly navLogoKind: NavLogoKind;
	readonly tooltip: string;
	readonly selected?: boolean;
}
export interface IBottomItem extends IBottomItemCore {
	readonly subItems?: IBottomSubItem[];
	readonly submenuWidth?: SubmenuWidth;
	readonly skipSubmenuHighlightIfMatchesOneOfThesePaths?: string[];
}
export interface IBottomSubItem extends IBottomItemCore {}

export interface IBottomItemCore {
	readonly label: string;
	readonly tooltip: string;
	readonly href?: string;
	readonly buttonStyle?: boolean;
	readonly allowhighlight?: boolean;
	readonly image?: string;
	readonly mobileImage?: string;
	readonly allowedScreenSizeMode?: ScreenSizeMode;
}

export interface ISiteIdentityLogoLink {
	navLogoKind: NavLogoKind;
	tooltip: string;
}

export type ScreenSizeMode = "desktop" | "mobile" | "any";

